import {
  AscmuMonitoringSetting,
} from "models/ascmu-monitoring-setting";
import {
  MonitoringDeviceAlreadyUsedError,
} from "repositories/modules/monitoring-settings";

import {
  axiosInstance as Repository,
  RESULT_CD,
  RepositoryError,
} from "../repository";

const RESOURCE = "/monitoring-target";

/* カスタム例外 */
class AscmuMonitoringSettingsRepositoryError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AscmuMonitoringSettingsRepositoryError.getErrorCd();
  }

  static getErrorCd() {
    return "09010";
  }
}

class AscmuMonitoringSettingAlreadyExistsError extends AscmuMonitoringSettingsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AscmuMonitoringSettingAlreadyExistsError.getErrorCd();
  }

  static getErrorCd() {
    return "09011";
  }
}

class AscmuAlreadyUsedError extends AscmuMonitoringSettingsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AscmuAlreadyUsedError.getErrorCd();
  }

  static getErrorCd() {
    return "09012";
  }
}

/* API Response と modelの変換 */
function getInstance(item) {
  const monitoringTargetId = item.monitoring_target_id;
  const monitoringSettingId = item.monitoring_setting_id;
  const monitoringSetting = new AscmuMonitoringSetting(monitoringTargetId, monitoringSettingId);
  monitoringSetting.setApiResponseJosn(item);

  return monitoringSetting;
}

function makeRequestJson(monitoringSetting) {
  return monitoringSetting.getApiRequestJson();
}

const AscmuMonitoringSettingsRepository = {
  async store(monitoringSetting) {
    const urlParams = {
      monitoringTargetId: monitoringSetting.monitoringTargetId,
    };
    const requestParams = makeRequestJson(monitoringSetting);
    const response = await Repository.post(`${RESOURCE}/${urlParams.monitoringTargetId}/monitoring-settings/ascmu`, requestParams);

    console.log(response.data);
    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      if (response.data.errors[0].error_cd === MonitoringDeviceAlreadyUsedError.getErrorCd()) {
        throw new MonitoringDeviceAlreadyUsedError();
      } else {
        throw new AscmuMonitoringSettingsRepositoryError();
      }
    }

    return getInstance(response.data.item);
  },

  async update(monitoringSetting) {
    const urlParams = {
      monitoringTargetId: monitoringSetting.monitoringTargetId,
    };
    urlParams.monitoringSettingId = monitoringSetting.monitoringSettingId;
    const requestParams = makeRequestJson(monitoringSetting);
    const response = await Repository.put(`${RESOURCE}/${urlParams.monitoringTargetId}/monitoring-settings/ascmu/${urlParams.monitoringSettingId}`, requestParams);

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new AscmuMonitoringSettingsRepositoryError();
    }

    return getInstance(response.data.item);
  },

  async index(monitoringTargetId) {
    const urlParams = {
      monitoringTargetId,
    };
    const response = await Repository.get(`${RESOURCE}/${urlParams.monitoringTargetId}/monitoring-settings/ascmu`, {
      params: {},
    });

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new AscmuMonitoringSettingsRepositoryError();
    }

    const items = [];
    response.data.items.forEach((item) => {
      if (item.monitoring_setting_type === "ascmu") {
        items.push(getInstance(item));
      }
    });
    return items;
  },

  async get(monitoringTargetId, monitoringSettingId) {
    const urlParams = {
      monitoringTargetId,
    };
    urlParams.monitoringSettingId = monitoringSettingId;
    const response = await Repository.get(`${RESOURCE}/${urlParams.monitoringTargetId}/monitoring-settings/ascmu/${urlParams.monitoringSettingId}`, {
      params: {},
    });

    // 処理結果のチェック
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new AscmuMonitoringSettingsRepositoryError();
    }

    return getInstance(response.data.item);
  },

  async destroy(monitoringTargetId, monitoringSettingId) {
    const urlParams = {
      monitoringTargetId,
    };
    urlParams.monitoringSettingId = monitoringSettingId;
    const response = await Repository.delete(`${RESOURCE}/${urlParams.monitoringTargetId}/monitoring-settings/ascmu/${urlParams.monitoringSettingId}`, {
      params: {},
    });

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new AscmuMonitoringSettingsRepositoryError();
    }
  },

  async upsert(monitoringSetting) {
    let res = null;
    if (monitoringSetting.monitoringSettingId === null) {
      res = this.store(monitoringSetting);
    } else {
      res = this.update(monitoringSetting);
    }
    return res;
  },
};

export {
  AscmuMonitoringSettingsRepository,
  AscmuMonitoringSettingsRepositoryError,
  AscmuMonitoringSettingAlreadyExistsError,
  AscmuAlreadyUsedError,
};
